import { render, staticRenderFns } from "./u-form-item.vue?vue&type=template&id=15351245&scoped=true&"
import script from "./u-form-item.vue?vue&type=script&lang=js&"
export * from "./u-form-item.vue?vue&type=script&lang=js&"
import style0 from "./u-form-item.vue?vue&type=style&index=0&id=15351245&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15351245",
  null
  
)

export default component.exports